// ABOUTME: Page shown after a successful Stripe Checkout payment.
// ABOUTME: Reads gameId from query string and links back to the game manage page.
import Typography from '@mui/material/Typography'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import { Link, useSearchParams } from 'react-router'

export function BillingSuccessPage() {
  const [params] = useSearchParams()
  const gameId = params.get('gameId')

  return (
    <Container maxWidth="sm">
      <Box mt={8} textAlign="center">
        <Typography variant="h4" gutterBottom>
          Payment successful!
        </Typography>
        <Typography color="text.secondary" mb={4}>
          Your game can now accept more players.
        </Typography>
        {gameId && (
          <Button component={Link} to={`/games/${gameId}/manage`} variant="contained">
            Back to game
          </Button>
        )}
      </Box>
    </Container>
  )
}
